import React from 'react';
import Navbar from './Navbar';
import Footer from './Footer';

const Layout = ({ children }) => {
    return (
        <>
            <Navbar />
            <main>
                {/* Il contenuto della pagina (es. HomePage, PassageReport)
                    verrà iniettato qui */}
                {children}
            </main>
        </>
    );
};

export default Layout;